{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Huỷ",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Tích hợp",
    "DESCRIPTION": "Trung tâm liên lạc tích hợp với nhiều công cụ và dịch vụ để nâng cao hiệu quả của nhóm bạn. Khám phá danh sách bên dưới để cấu hình các ứng dụng yêu thích của bạn.",
    "LEARN_MORE": "Learn more about integrations",
    "LOADING": "Fetching integrations",
    "CAPTAIN": {
      "DISABLED": "Captain is not enabled on your account.",
      "CLICK_HERE_TO_CONFIGURE": "Click here to configure",
      "LOADING_CONSOLE": "Loading Captain Console...",
      "FAILED_TO_LOAD_CONSOLE": "Failed to load Captain Console. Please refresh and try again."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Những sự kiện được theo dõi",
      "LEARN_MORE": "Learn more about webhooks",
      "FORM": {
        "CANCEL": "Huỷ",
        "DESC": "Webhook events cung cấp cho bạn thông tin thời gian thực về những gì đang xảy ra trong tài khoản của bạn. Vui lòng nhập một URL hợp lệ để định cấu hình một cuộc gọi lại.",
        "SUBSCRIPTIONS": {
          "LABEL": "Các sự kiện",
          "EVENTS": {
            "INBOX_CREATED": "Đã tạo hộp thư đến",
            "CONVERSATION_CREATED": "Cuộc trò chuyện đã được tạo",
            "CONVERSATION_STATUS_CHANGED": "Trạng thái cuộc trò chuyện đã thay đổi",
            "CONVERSATION_UPDATED": "Cuộc trò chuyện đã được cập nhật",
            "MESSAGE_CREATED": "Tin nhắn đã được tạo",
            "MESSAGE_UPDATED": "Tin nhắn đã được cập nhật",
            "WEBWIDGET_TRIGGERED": "Tiện ích trò chuyện trực tuyến do người dùng mở",
            "CONTACT_CREATED": "Contact created",
            "CONTACT_UPDATED": "Contact updated",
            "JARABOT_EVENT": "Internal events"
          }
        },
        "END_POINT": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Example: {webhookExampleURL}",
          "ERROR": "Vui lòng nhập một URL hợp lệ"
        },
        "EDIT_SUBMIT": "Cập nhật webhook",
        "ADD_SUBMIT": "Tạo webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Cấu hình",
      "HEADER": "Cài đặt Webhook",
      "HEADER_BTN_TXT": "Thêm mới webhook",
      "LOADING": "Đang tải về các webhooks",
      "SEARCH_404": "Không có kết quả nào được tìm thấy",
      "SIDEBAR_TXT": "<p><b>Webhooks</b> </p> <p>Webhook là các lệnh gọi lại HTTP có thể được xác định cho mọi tài khoản. Chúng được kích hoạt bởi các sự kiện như tạo tin nhắn. Bạn có thể tạo nhiều webhook cho tài khoản này. <br /><br /> Để tạo một <b>webhook</b>, click vào <b>Tạo mới</b>. Bạn cũng có thể xóa bất kỳ webhook hiện có nào bằng cách nhấp vào nút Xóa.</p>",
      "LIST": {
        "404": "Không có webhook nào được định cấu hình cho tài khoản này.",
        "TITLE": "Quản lý webhooks",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhook endpoint",
          "ACTIONS": "Hành động"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Chỉnh sửa",
        "TITLE": "Sửa webhook",
        "API": {
          "SUCCESS_MESSAGE": "Đã cập nhật cấu hình Webhook thành công",
          "ERROR_MESSAGE": "Không thể kết nối với Máy chủ Woot, Vui lòng thử lại sau"
        }
      },
      "ADD": {
        "CANCEL": "Xoá",
        "TITLE": "Thêm mới webhook",
        "API": {
          "SUCCESS_MESSAGE": "Đã thêm Webhook thành công",
          "ERROR_MESSAGE": "Không thể kết nối với Máy chủ Woot, Vui lòng thử lại sau"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Xoá",
        "API": {
          "SUCCESS_MESSAGE": "Webhook đã được xoá thành công",
          "ERROR_MESSAGE": "Không thể kết nối với Máy chủ Woot, Vui lòng thử lại sau"
        },
        "CONFIRM": {
          "TITLE": "Xác Nhận Xoá",
          "MESSAGE": "Bạn có chắc chắn muốn xóa webhook không? ({webhookURL})",
          "YES": "Có, Xoá ",
          "NO": "Không, Giữ"
        }
      },
      "DISABLED_BADGE": "Đã tắt",
      "DISABLED_REASON": "Tự động tắt sau {count} lần thất bại liên tiếp. Lỗi gần nhất: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Bật",
        "API": {
          "SUCCESS_MESSAGE": "Đã bật webhook thành công",
          "ERROR_MESSAGE": "Không thể bật webhook, vui lòng thử lại sau"
        }
      }
    },
    "SLACK": {
      "DELETE": "Xoá",
      "DELETE_CONFIRMATION": {
        "TITLE": "Delete the integration",
        "MESSAGE": "Are you sure you want to delete the integration? Doing so will result in the loss of access to conversations on your Slack workspace."
      },
      "HELP_TEXT": {
        "TITLE": "Dùng tích hợp Slack",
        "BODY": "Với tích hợp này, tất cả các cuộc trò chuyện đến của bạn sẽ được đồng bộ với kênh ***{selectedChannelName}*** trong không gian làm việc Slack của bạn. Bạn có thể quản lý mọi cuộc trò chuyện với khách hàng ngay trong kênh và không bao giờ bỏ lỡ tin nhắn nào.\n\nĐây là các tính năng chính của tích hợp:\n\n**Trả lời cuộc trò chuyện ngay trong Slack:** Để trả lời một cuộc trò chuyện trong kênh Slack ***{selectedChannelName}***, hãy nhập tin nhắn của bạn và gửi dưới dạng một luồng. Thao tác này sẽ tạo một phản hồi gửi đến khách hàng thông qua trung tâm liên lạc. Thật đơn giản!\n\n **Tạo ghi chú riêng tư:** Nếu bạn muốn tạo ghi chú riêng tư thay vì trả lời, hãy bắt đầu tin nhắn bằng ***`note:`***. Điều này đảm bảo tin nhắn của bạn được giữ riêng tư và khách hàng sẽ không nhìn thấy.\n\n**Liên kết hồ sơ tổng đài viên:** Nếu người trả lời trên Slack có hồ sơ tổng đài viên trong trung tâm liên lạc với cùng địa chỉ email, các câu trả lời sẽ tự động được liên kết với hồ sơ tổng đài viên đó. Nhờ vậy bạn có thể dễ dàng theo dõi ai đã nói gì và khi nào. Ngược lại, nếu người trả lời không có hồ sơ tổng đài viên được liên kết, khách hàng sẽ thấy các câu trả lời từ hồ sơ bot.",
        "SELECTED": "selected"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Select a channel",
        "UPDATE": "Cập nhật",
        "BUTTON_TEXT": "Connect channel",
        "DESCRIPTION": "Không gian làm việc Slack của bạn hiện đã được liên kết với trung tâm liên lạc. Tuy nhiên, tích hợp hiện chưa hoạt động. Để kích hoạt tích hợp và kết nối một kênh, vui lòng nhấp vào nút bên dưới.\n\n**Lưu ý:** Nếu bạn đang cố kết nối một kênh riêng tư, hãy thêm ứng dụng của chúng tôi vào kênh Slack trước khi thực hiện bước này.",
        "ATTENTION_REQUIRED": "Attention required",
        "EXPIRED": "Your Slack integration has expired. To continue receiving messages on Slack, please delete the integration and connect your workspace again."
      },
      "UPDATE_ERROR": "There was an error updating the integration, please try again",
      "UPDATE_SUCCESS": "The channel is connected successfully",
      "FAILED_TO_FETCH_CHANNELS": "There was an error fetching the channels from Slack, please try again"
    },
    "OPEN_AI": {
      "AI_ASSIST": "Trợ lý AI",
      "WITH_AI": " {option} bằng AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Gợi ý trả lời",
        "SUMMARIZE": "Tóm tắt",
        "REPHRASE": "Cải thiện cách viết",
        "FIX_SPELLING_GRAMMAR": "Sửa lỗi chính tả và ngữ pháp",
        "SHORTEN": "Rút gọn",
        "EXPAND": "Mở rộng",
        "MAKE_FRIENDLY": "Đổi giọng điệu tin nhắn sang thân thiện",
        "MAKE_FORMAL": "Dùng giọng điệu trang trọng",
        "SIMPLIFY": "Đơn giản hoá",
        "TRANSLATE": "Dịch",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Dịch sang ngôn ngữ phổ biến"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Nội dung nháp",
        "GENERATED_TITLE": "Nội dung được tạo",
        "AI_WRITING": "AI đang viết",
        "BUTTONS": {
          "APPLY": "Dùng gợi ý này",
          "CANCEL": "Huỷ"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Tích hợp với OpenAI",
        "DESC": "Mang các tính năng AI nâng cao đến trang tổng quan của bạn với các mô hình GPT của OpenAI. Để bắt đầu, hãy nhập khoá API từ tài khoản OpenAI của bạn.",
        "KEY_PLACEHOLDER": "Nhập khoá API OpenAI của bạn",
        "BUTTONS": {
          "NEED_HELP": "Cần hỗ trợ?",
          "DISMISS": "Bỏ qua",
          "FINISH": "Hoàn tất thiết lập"
        },
        "DISMISS_MESSAGE": "Bạn có thể thiết lập tích hợp OpenAI sau, bất cứ khi nào bạn muốn.",
        "SUCCESS_MESSAGE": "Thiết lập tích hợp OpenAI thành công"
      },
      "TITLE": "Cải thiện bằng AI",
      "SUMMARY_TITLE": "Tóm tắt bằng AI",
      "REPLY_TITLE": "Gợi ý trả lời bằng AI",
      "SUBTITLE": "Một câu trả lời được cải thiện sẽ được tạo bằng AI, dựa trên bản nháp hiện tại của bạn.",
      "TONE": {
        "TITLE": "Giọng điệu",
        "OPTIONS": {
          "PROFESSIONAL": "Chuyên nghiệp",
          "FRIENDLY": "Thân thiện"
        }
      },
      "BUTTONS": {
        "GENERATE": "Tạo",
        "GENERATING": "Đang tạo...",
        "CANCEL": "Huỷ"
      },
      "GENERATE_ERROR": "There was an error processing the content, please try again"
    },
    "DELETE": {
      "BUTTON_TEXT": "Xoá",
      "API": {
        "SUCCESS_MESSAGE": "Tích hợp đã được xóa thành công"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Kết nối"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Ứng dụng bảng điều khiển",
      "HEADER_BTN_TXT": "Thêm mới một Ứng dụng bảng điều khiển",
      "SIDEBAR_TXT": "<p> <b> Ứng dụng trên bảng điều khiển</b> </p> <p>Ứng dụng bảng điều khiển cho phép nhúng ứng dụng vào trang bảng điều khiển để cung cấp ngữ cảnh cho các tổng đài viên hỗ trợ khách hàng. Tính năng này cho phép bạn tạo ứng dụng một cách độc lập và nhúng ứng dụng đó vào bên trong trang điều khiển để cung cấp thông tin người dùng, đơn đặt hàng hoặc lịch sử thanh toán trước đó của họ. </p> <p> Khi bạn nhúng ứng dụng của mình bằng điều khiển, ứng dụng của bạn sẽ lấy bối cảnh của cuộc trò chuyện và liên hệ dưới dạng sự kiện cửa sổ. Triển khai trình nghe cho sự kiện thông báo trên trang của bạn để nhận ngữ cảnh. </p> <p> Để thêm ứng dụng trang điều khiển mới, hãy nhấp vào nút 'Thêm ứng dụng bảng điều khiển mới'. </p>",
      "DESCRIPTION": "Ứng dụng bảng điều khiển cho phép các tổ chức nhúng một ứng dụng bên trong trang điều khiển để cung cấp ngữ cảnh cho các tổng đài viên hỗ trợ khách hàng. Tính năng này cho phép bạn tạo ứng dụng một cách độc lập và nhúng ứng dụng đó để cung cấp thông tin người dùng, đơn đặt hàng hoặc lịch sử thanh toán trước đó của họ.",
      "LEARN_MORE": "Learn more about Dashboard Apps",
      "LIST": {
        "404": "Chưa có ứng dụng trang \u001dđiều khiển nào được định cấu hình trên tài khoản này",
        "LOADING": "Đang tìm nạp ứng dụng bảng điều khiển...",
        "TABLE_HEADER": {
          "NAME": "Tên",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Sửa app",
        "DELETE_TOOLTIP": "Xoá app"
      },
      "FORM": {
        "TITLE_LABEL": "Tên",
        "TITLE_PLACEHOLDER": "Nhập tên cho ứng dụng bảng điều khiển",
        "TITLE_ERROR": "Cần có tên cho ứng dụng bảng điều khiển",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Nhập URL endpoint nơi ứng dụng của bạn được lưu trữ",
        "URL_ERROR": "Cần một URL hợp lệ"
      },
      "CREATE": {
        "HEADER": "Thêm mới một Ứng dụng bảng điều khiển",
        "FORM_SUBMIT": "Gửi",
        "FORM_CANCEL": "Huỷ",
        "API_SUCCESS": "Ứng dụng trang điều khiển được định cấu hình thành công",
        "API_ERROR": "Chúng tôi không thể tạo ứng dụng. Vui lòng thử lại sau"
      },
      "UPDATE": {
        "HEADER": "Sửa app bảng điều khiển",
        "FORM_SUBMIT": "Cập nhật",
        "FORM_CANCEL": "Huỷ",
        "API_SUCCESS": "Đã cập nhật ứng dụng trang điều khiển thành công",
        "API_ERROR": "Chúng tôi không thể cập nhật ứng dụng. Vui lòng thử lại sau"
      },
      "DELETE": {
        "CONFIRM_YES": "Có, xóa nó",
        "CONFIRM_NO": "Không, giữ nó",
        "TITLE": "Xác nhận xoá",
        "MESSAGE": "Bạn có chắc chắn xóa ứng dụng - {appName}?",
        "API_SUCCESS": "Đã xóa ứng dụng trang điều khiển thành công",
        "API_ERROR": "Chúng tôi không thể xóa ứng dụng. Vui lòng thử lại sau"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Create/Link Linear Issue",
      "LOADING": "Fetching linear issues...",
      "LOADING_ERROR": "There was an error fetching the linear issues, please try again",
      "CREATE": "Tạo",
      "LINK": {
        "SEARCH": "Search issues",
        "SELECT": "Select issue",
        "TITLE": "Liên kết",
        "EMPTY_LIST": "No linear issues found",
        "LOADING": "Loading",
        "ERROR": "There was an error fetching the linear issues, please try again",
        "LINK_SUCCESS": "Issue linked successfully",
        "LINK_ERROR": "There was an error linking the issue, please try again",
        "LINK_TITLE": "Conversation (#{conversationId}) with {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Create/link linear issue",
        "DESCRIPTION": "Create Linear issues from conversations, or link existing ones for seamless tracking.",
        "FORM": {
          "TITLE": {
            "LABEL": "Tiêu đề",
            "PLACEHOLDER": "Enter title",
            "REQUIRED_ERROR": "Tiêu đề bắt buộc có"
          },
          "DESCRIPTION": {
            "LABEL": "Mô tả",
            "PLACEHOLDER": "Enter description"
          },
          "TEAM": {
            "LABEL": "Nhóm",
            "PLACEHOLDER": "Chọn nhóm",
            "SEARCH": "Search team",
            "REQUIRED_ERROR": "Team is required"
          },
          "ASSIGNEE": {
            "LABEL": "Assignee",
            "PLACEHOLDER": "Select assignee",
            "SEARCH": "Search assignee"
          },
          "PRIORITY": {
            "LABEL": "Mức độ ưu tiên",
            "PLACEHOLDER": "Chọc mức ưu tiên",
            "SEARCH": "Search priority"
          },
          "LABEL": {
            "LABEL": "Nhãn",
            "PLACEHOLDER": "Select label",
            "SEARCH": "Search label"
          },
          "STATUS": {
            "LABEL": "Trạng thái",
            "PLACEHOLDER": "Select status",
            "SEARCH": "Search status"
          },
          "PROJECT": {
            "LABEL": "Project",
            "PLACEHOLDER": "Select project",
            "SEARCH": "Search project"
          }
        },
        "CREATE": "Tạo",
        "CANCEL": "Huỷ",
        "CREATE_SUCCESS": "Issue created successfully",
        "CREATE_ERROR": "There was an error creating the issue, please try again",
        "LOADING_TEAM_ERROR": "There was an error fetching the teams, please try again",
        "LOADING_TEAM_ENTITIES_ERROR": "There was an error fetching the team entities, please try again"
      },
      "ISSUE": {
        "STATUS": "Trạng thái",
        "PRIORITY": "Mức độ ưu tiên",
        "ASSIGNEE": "Assignee",
        "LABELS": "Nhãn",
        "CREATED_AT": "Created at {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Unlink",
        "SUCCESS": "Issue unlinked successfully",
        "ERROR": "There was an error unlinking the issue, please try again"
      },
      "DELETE": {
        "TITLE": "Are you sure you want to delete the integration?",
        "MESSAGE": "Are you sure you want to delete the integration?",
        "CONFIRM": "Có, xoá",
        "CANCEL": "Huỷ"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Captain",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Gửi tin nhắn...",
      "EMPTY_MESSAGE": "Đã xảy ra lỗi khi tạo câu trả lời. Vui lòng thử lại.",
      "LOADER": "Captain is thinking",
      "YOU": "You",
      "USE": "Use this",
      "RESET": "Reset",
      "SELECT_ASSISTANT": "Select Assistant"
    },
    "PAYWALL": {
      "TITLE": "Upgrade to use Captain AI",
      "AVAILABLE_ON": "Captain is not available on the free plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "UPGRADE_NOW": "Upgrade now",
      "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI feature is only available in a paid plan.",
      "UPGRADE_PROMPT": "Upgrade your plan to get access to our assistants, copilot and more.",
      "ASK_ADMIN": "Please reach out to your administrator for the upgrade."
    },
    "BANNER": {
      "RESPONSES": "You've used over 80% of your response limit. To continue using Captain AI, please upgrade.",
      "DOCUMENTS": "Document limit reached. Upgrade to continue using Captain AI."
    },
    "FORM": {
      "CANCEL": "Huỷ",
      "CREATE": "Tạo",
      "EDIT": "Cập nhật"
    },
    "ASSISTANTS": {
      "HEADER": "Assistants",
      "ADD_NEW": "Create a new assistant",
      "DELETE": {
        "TITLE": "Are you sure to delete the assistant?",
        "DESCRIPTION": "This action is permanent. Deleting this assistant will remove it from all connected inboxes and permanently erase all generated knowledge.",
        "CONFIRM": "Có, xoá",
        "SUCCESS_MESSAGE": "The assistant has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the assistant, please try again."
      },
      "FORM_DESCRIPTION": "Fill out the details below to name your assistant, describe its purpose, and specify the product it will support.",
      "CREATE": {
        "TITLE": "Create an assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the assistant, please try again."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Assistant Name",
          "PLACEHOLDER": "Enter a name for the assistant",
          "ERROR": "Please provide a name for the assistant"
        },
        "DESCRIPTION": {
          "LABEL": "Assistant Description",
          "PLACEHOLDER": "Describe how and where this assistant will be used",
          "ERROR": "A description is required"
        },
        "PRODUCT_NAME": {
          "LABEL": "Product Name",
          "PLACEHOLDER": "Enter the name of the product this assistant is designed for",
          "ERROR": "The product name is required"
        },
        "FEATURES": {
          "TITLE": "Các tính năng",
          "ALLOW_CONVERSATION_FAQS": "Generate FAQs from resolved conversations",
          "ALLOW_MEMORIES": "Capture key details as memories from customer interactions."
        }
      },
      "EDIT": {
        "TITLE": "Update the assistant",
        "SUCCESS_MESSAGE": "The assistant has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the assistant, please try again."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Edit Assistant",
        "DELETE_ASSISTANT": "Delete Assistant",
        "VIEW_CONNECTED_INBOXES": "View connected inboxes"
      },
      "EMPTY_STATE": {
        "TITLE": "No assistants available",
        "SUBTITLE": "Create an assistant to provide quick and accurate responses to your users. It can learn from your help articles and past conversations.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Documents",
      "ADD_NEW": "Create a new document",
      "RELATED_RESPONSES": {
        "TITLE": "Related FAQs",
        "DESCRIPTION": "These FAQs are generated directly from the document."
      },
      "FORM_DESCRIPTION": "Enter the URL of the document to add it as a knowledge source and choose the assistant to associate it with.",
      "CREATE": {
        "TITLE": "Add a document",
        "SUCCESS_MESSAGE": "The document has been successfully created",
        "ERROR_MESSAGE": "There was an error creating the document, please try again."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Enter the URL of the document",
          "ERROR": "Please provide a valid URL for the document"
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select the assistant",
          "ERROR": "The assistant field is required"
        }
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the document?",
        "DESCRIPTION": "This action is permanent. Deleting this document will permanently erase all generated knowledge.",
        "CONFIRM": "Có, xoá",
        "SUCCESS_MESSAGE": "The document has been successfully deleted",
        "ERROR_MESSAGE": "There was an error deleting the document, please try again."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "View Related Responses",
        "DELETE_DOCUMENT": "Delete Document"
      },
      "EMPTY_STATE": {
        "TITLE": "No documents available",
        "SUBTITLE": "Documents are used by your assistant to generate FAQs. You can import documents to provide context for your assistant.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "FAQs",
      "ADD_NEW": "Create new FAQ",
      "DOCUMENTABLE": {
        "CONVERSATION": "Conversation #{id}"
      },
      "SELECTED": "{count} selected",
      "BULK_APPROVE_BUTTON": "Approve",
      "BULK_DELETE_BUTTON": "Xoá",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "FAQs approved successfully",
        "ERROR_MESSAGE": "There was an error approving the FAQs, please try again."
      },
      "BULK_DELETE": {
        "TITLE": "Delete FAQs?",
        "DESCRIPTION": "Are you sure you want to delete the selected FAQs? This action cannot be undone.",
        "CONFIRM": "Yes, delete all",
        "SUCCESS_MESSAGE": "FAQs deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQs, please try again."
      },
      "DELETE": {
        "TITLE": "Are you sure to delete the FAQ?",
        "DESCRIPTION": "",
        "CONFIRM": "Có, xoá",
        "SUCCESS_MESSAGE": "FAQ deleted successfully",
        "ERROR_MESSAGE": "There was an error deleting the FAQ, please try again."
      },
      "FILTER": {
        "ASSISTANT": "Assistant: {selected}",
        "STATUS": "Status: {selected}",
        "ALL_ASSISTANTS": "Tất cả"
      },
      "STATUS": {
        "TITLE": "Trạng thái",
        "PENDING": "Chờ giải quyết",
        "APPROVED": "Approved",
        "ALL": "Tất cả"
      },
      "FORM_DESCRIPTION": "Add a question and its corresponding answer to the knowledge base and select the assistant it should be associated with.",
      "CREATE": {
        "TITLE": "Add an FAQ",
        "SUCCESS_MESSAGE": "The response has been added successfully.",
        "ERROR_MESSAGE": "An error occurred while adding the response. Please try again."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Question",
          "PLACEHOLDER": "Enter the question here",
          "ERROR": "Please provide a valid question."
        },
        "ANSWER": {
          "LABEL": "Answer",
          "PLACEHOLDER": "Enter the answer here",
          "ERROR": "Please provide a valid answer."
        },
        "ASSISTANT": {
          "LABEL": "Assistant",
          "PLACEHOLDER": "Select an assistant",
          "ERROR": "Please select an assistant."
        }
      },
      "EDIT": {
        "TITLE": "Update the FAQ",
        "SUCCESS_MESSAGE": "The FAQ has been successfully updated",
        "ERROR_MESSAGE": "There was an error updating the FAQ, please try again",
        "APPROVE_SUCCESS_MESSAGE": "The FAQ was marked as approved"
      },
      "OPTIONS": {
        "APPROVE": "Mark as approved",
        "EDIT_RESPONSE": "Edit FAQ",
        "DELETE_RESPONSE": "Delete FAQ"
      },
      "EMPTY_STATE": {
        "TITLE": "No FAQs Found",
        "SUBTITLE": "FAQs help your assistant provide quick and accurate answers to questions from your customers. They can be generated automatically from your content or can be added manually.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Connected Inboxes",
      "ADD_NEW": "Connect a new inbox",
      "OPTIONS": {
        "DISCONNECT": "Ngắt kết nối"
      },
      "DELETE": {
        "TITLE": "Are you sure to disconnect the inbox?",
        "DESCRIPTION": "",
        "CONFIRM": "Có, xoá",
        "SUCCESS_MESSAGE": "The inbox was successfully disconnected.",
        "ERROR_MESSAGE": "There was an error disconnecting the inbox, please try again."
      },
      "FORM_DESCRIPTION": "Choose an inbox to connect with the assistant.",
      "CREATE": {
        "TITLE": "Connect an Inbox",
        "SUCCESS_MESSAGE": "The inbox was successfully connected.",
        "ERROR_MESSAGE": "An error occurred while connecting the inbox. Please try again."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Hộp thư đến",
          "PLACEHOLDER": "Choose the inbox to deploy the assistant.",
          "ERROR": "An inbox selection is required."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No Connected Inboxes",
        "SUBTITLE": "Connecting an inbox allows the assistant to handle initial questions from your customers before transferring them to you."
      }
    }
  }
}
